// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo-module__root--Tx0rJ"};